import * as userService from './userService';
import * as accountService from './accountService';
import * as commonService from './commonService';
import * as diagnosisService from './diagnosisService';
import * as fileService from './fileService';
import * as userManageService from './userManageService'
import * as onlineService from './onlineService'
const obj={
    userService,accountService,commonService,diagnosisService,fileService,userManageService,onlineService
}
export default obj;